import React, { memo } from 'react';
import { useSnackbar, Snackbar as FrontonSnackbar, Snack, SnackButton } from 'fronton-react';

export const Snackbar = memo(() => {
  const { state, removeSnack } = useSnackbar();

  return (
    <FrontonSnackbar horizontalPosition="center" verticalPosition="top">
      {state.map(({ id, title, content, type, button, time, wide }) => (
        <Snack
          key={id}
          id={id}
          header={title}
          paragraph={content}
          variant={type}
          wideButton={wide}
          autoHideTimer={time ? 3000 : undefined}>
          {button && <SnackButton onClick={() => removeSnack(id)}>Закрыть</SnackButton>}
        </Snack>
      ))}
    </FrontonSnackbar>
  );
});
